import { render } from "./ArticleView.vue?vue&type=template&id=bbefb30a&scoped=true&ts=true"
import script from "./ArticleView.vue?vue&type=script&lang=ts"
export * from "./ArticleView.vue?vue&type=script&lang=ts"

import "./ArticleView.vue?vue&type=style&index=0&id=bbefb30a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbefb30a"]])

export default __exports__